import {getGlobalObject} from '../utils';
import {createSnHttp} from '@servicenow/ui-utils';

const root = getGlobalObject();
let localSnHttp = null;

const createSnHttpForGql = async () => {
	if (!localSnHttp) {
		const snHttpConfig = {
			xsrfToken: root.g_ck,
			xTransactionSource: root.transaction_source,
			batching: false
		};
		const snHttpFactory = createSnHttp(snHttpConfig);
		localSnHttp = await snHttpFactory();
	}
	return localSnHttp;
};

export default createSnHttpForGql;
